// extracted by mini-css-extract-plugin
export default {"menu":"ClientMenu_menu__28X5S","menu_item":"ClientMenu_menu_item__iFkvd","deleteItem":"ClientMenu_deleteItem__zFYQz","menu_invitation":"ClientMenu_menu_invitation__7aej2"};